export default __webpack_public_path__ + "static/media/tip-color-logo.784a7a34.svg";